import { SHOW_SCHEDULE_EDIT_TIME, HIDE_SCHEDULE_EDIT_TIME } from './types'

export const showScheduleEditTime = (data) => ({
  type: SHOW_SCHEDULE_EDIT_TIME,
  position: data.position,
  data: data.data
})

export const hideScheduleEditTime = () => ({
  type: HIDE_SCHEDULE_EDIT_TIME,
})
